// Home page functionality for Foods of Garden Grove
import { openScannerModal, initScannerStyles } from './qr-scanner.js';

// Initialize QR scanner styles on page load
initScannerStyles();

// Set up Check In button click handler
document.addEventListener('DOMContentLoaded', () => {
  const checkinBtn = document.getElementById('home-checkin-btn');
  
  if (checkinBtn) {
    checkinBtn.addEventListener('click', () => {
      console.log('Opening QR scanner from home page...');
      openScannerModal();
    });
  }
});
